import checkPermission from '@/utils/permission'
import lang from '@/lang'
import { matchView, refreshView } from '@/store/modules/tagsView'
import lodash from 'lodash'
import {
  LOG_CARRY_FORWARD_CHARGE,
  LOG_CARRY_FORWARD_CHARGE_ADVANCE,
  LOG_FINANCIAL_REVIEW_CHARGE,
  LOG_FINANCIAL_REVIEW_CHARGE_ADVANCE, LOG_JUMP_FINANCE,
  LOG_MAKE_INVOICE_CHARGE, LOG_MAKE_INVOICE_CHARGE_ADVANCE,
  LOG_RECONCILIATION_CHARGE,
  LOG_RECONCILIATION_CHARGE_ADVANCE, LOG_WRITE_OFF_CHARGE, LOG_WRITE_OFF_CHARGE_ADVANCE
} from '@/class/cargo/model/parameters/SystemConstants'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'

/**
 * 获取跳转财务审核/业务的属性
 * @param useRoute
 * @param usePrint
 * @param jobNo
 * @param lob
 * @param branchId
 * @param printMethod
 * @returns
 */
export function getJumpFinaceOrBusinessAttrs(useRoute, usePrint, jobNo, lob, branchId, printMethod) {
  if (checkPermission(['module_ACVerify'])) {
    return {
      useRoute,
      usePrint,
      routeName: 'FinanceManage',
      routeTitle: lang.t('CargoMsg.Cargo_FinancialAudit'),
      routePermissions: ['module_ACVerify'],
      extraRouteParams: { jobNo },
      printMethod
    }
  }
  switch (lob) {
    case 'AI':
      return {
        useRoute,
        usePrint,
        routeName: 'AiBooking',
        routeTitle: lang.t('SeaExport.AirOperation'),
        routePermissions: ['module_AIBooking'],
        extraRouteData: { jobNo, branchId },
        printMethod
      }
    case 'AE':
      return {
        useRoute,
        usePrint,
        routeName: 'AeBooking',
        routeTitle: lang.t('route.airExportBooking'),
        routePermissions: ['module_AEBooking'],
        extraRouteParams: { jobNo },
        extraRouteData: { branchId },
        printMethod
      }
    case 'SI':
      return {
        useRoute,
        usePrint,
        routeName: 'SiBooking',
        routeTitle: lang.t('route.seaImportBooking'),
        routePermissions: ['module_SIBOOKING'],
        extraRouteData: { jobNo, branchId },
        printMethod
      }
    case 'SE':
      return {
        useRoute,
        usePrint,
        routeName: 'SeaBooking',
        routeTitle: lang.t('CargoMsg.Cargo_SeaBooking'),
        routePermissions: ['module_fmBookingNew'],
        extraRouteParams: { jobNo },
        extraRouteData: { branchId },
        printMethod
      }
    case 'RE':
    case 'RI':
      return {
        useRoute,
        usePrint,
        routeName: 'ReBooking',
        routeTitle: lang.t('CargoMsg.Cargo_RailwayOperate'),
        routePermissions: ['module_RailwayExport', 'module_RailwayOperations'],
        extraRouteParams: { jobNo },
        extraRouteData: { branchId },
        printMethod
      }
    case 'IE':
      return {
        useRoute,
        usePrint,
        routeName: 'IEBooking',
        routeTitle: lang.t('CargoMsg.Cargo_IntegratedOperate'),
        routePermissions: ['module_IEBooking'],
        extraRouteParams: { jobNo },
        extraRouteData: { branchId },
        printMethod
      }
    default:
      return {}
  }
}

/**
 * 跳转财务审核/业务
 * @param useRoute
 * @param usePrint
 * @param jobNo
 * @param lob
 * @param branchId
 * @returns
 */
export function jumpFinaceOrBusiness(view, jobNo, lob, branchId) {
  doJumpFinaceOrBusiness(view, jobNo, lob, branchId, false)
}
/**
 * 跳转财务审核/业务
 * @param useRoute
 * @param usePrint
 * @param jobNo
 * @param lob
 * @param branchId
 * @returns
 */
export function doJumpFinaceOrBusiness(view, jobNo, lob, branchId, bussiness) {
  let location = null
  if (view.$checkPermission(['module_ACVerify']) && !bussiness) {
    location = { name: 'FinanceManage', query: { jobNo }}
  } else {
    if (!lob) {
      if (jobNo.indexOf('SE') > -1) {
        lob = 'SE'
      } else if (jobNo.indexOf('SI') > -1) {
        lob = 'SI'
      } else if (jobNo.indexOf('AE') > -1) {
        lob = 'AE'
      } else if (jobNo.indexOf('AI') > -1) {
        lob = 'AI'
      } else if (jobNo.indexOf('RE') > -1) {
        lob = 'RE'
      } else if (jobNo.indexOf('RI') > -1) {
        lob = 'RI'
      } else if (jobNo.indexOf('IE') > -1) {
        lob = 'IE'
      } else {
        return
      }
    }
    switch (lob) {
      case 'SE':
        if (!view.$checkPermission(['module_fmBookingNew'])) {
          view.$message.error(view.$t('Message.YouToOpenTheModule', [view.$t('CargoMsg.Cargo_SeaBooking')]))
          return
        }
        location = { name: 'SeaBooking', query: { jobNo }, params: { branchId }}
        break
      case 'SI':
        if (!view.$checkPermission(['module_SIBOOKING'])) {
          view.$message.error(view.$t('Message.YouToOpenTheModule', [view.$t('route.seaImportBooking')]))
          return
        }
        location = { name: 'SiBooking', query: { }, params: { jobNo, branchId }}
        break
      case 'AE':
        if (!view.$checkPermission(['module_AEBooking'])) {
          view.$message.error(view.$t('Message.YouToOpenTheModule', [view.$t('route.airExportBooking')]))
          return
        }
        location = { name: 'AeBooking', query: { jobNo }, params: { branchId }}
        break
      case 'AI':
        if (!view.$checkPermission(['module_AIBooking'])) {
          view.$message.error(view.$t('Message.YouToOpenTheModule', [view.$t('SeaExport.AirOperation')]))
          return
        }
        location = { name: 'AiBooking', query: { }, params: { jobNo, branchId }}
        break
      case 'RE':
      case 'RI':
        if (!view.$checkPermission(['module_RailwayExport', 'module_RailwayOperations'])) {
          view.$message.error(view.$t('Message.YouToOpenTheModule', [view.$t('CargoMsg.Cargo_RailwayOperate')]))
          return
        }
        location = { name: 'ReBooking', query: { jobNo }, params: { branchId }}
        break
      case 'IE':
        if (!view.$checkPermission(['module_IEBooking'])) {
          view.$message.error(view.$t('Message.YouToOpenTheModule', [view.$t('CargoMsg.Cargo_IntegratedOperate')]))
          return
        }
        location = { name: 'IEBooking', query: { jobNo }, params: { branchId }}
        break
      default:
        return
    }
  }
  const oldRoute = view.$route
  view.$router.push(lodash.cloneDeep(location))
  setTimeout(() => {
    // 路由无变化，手动刷新
    if (view.$route === oldRoute) {
      const view = view.$store.state.tagsView.visitedViews.find(v => matchView(v, view.$route))
      Object.assign(view.params, location.params)
      refreshView(view)
    }
  }, 100)
}

/**
 * 跳转业务
 * @param useRoute
 * @param usePrint
 * @param jobNo
 * @param lob
 * @param branchId
 * @returns
 */
export function jumpBusiness(view, jobUuid, jobNo, lob, branchId, operationSource) {
  let location = null
  let activeTabName = ''
  if (operationSource.endsWith('Charge')) {
    activeTabName = 'tabCharges'
  } else if (operationSource.endsWith('ChargeAdvance')) {
    activeTabName = 'tabAdvanceCharge'
  }

  if (LOG_CARRY_FORWARD_CHARGE.code === operationSource || LOG_CARRY_FORWARD_CHARGE_ADVANCE.code === operationSource) {
    // 结账
    if (!view.$checkPermission(['module_ClosingAccount'])) {
      view.$message.error(view.$t('Message.YouToOpenTheModule', [view.$t('CargoMsg.Cargo_CarryForward')]))
      return
    }
    location = { name: 'ClosingAccount', query: { jobNo }, params: { activeTabName }}
  } else if (SystemConstants.getCommonState(operationSource, SystemConstants.LOG_JUMP_FINANCE)) {
    // 财务审核
    if (!view.$checkPermission(['module_ACVerify'])) {
      view.$message.error(view.$t('Message.YouToOpenTheModule', [view.$t('CargoMsg.Cargo_FinancialAudit')]))
      return
    }
    location = { name: 'FinanceManage', query: { jobNo }, params: { activeTabName }}
  } else {
    switch (lob) {
      case 'SE':
        if (!view.$checkPermission(['module_fmBookingNew'])) {
          view.$message.error(view.$t('Message.YouToOpenTheModule', [view.$t('CargoMsg.Cargo_SeaBooking')]))
          return
        }
        location = { name: 'SeaBooking', query: {}, params: { jobUuid, branchId, activeTabName }}
        break
      case 'SI':
        if (!view.$checkPermission(['module_SIBOOKING'])) {
          view.$message.error(view.$t('Message.YouToOpenTheModule', [view.$t('route.seaImportBooking')]))
          return
        }
        location = { name: 'SiBooking', query: {}, params: { jobNo, branchId, activeTabName }}
        break
      case 'AE':
        if (!view.$checkPermission(['module_AEBooking'])) {
          view.$message.error(view.$t('Message.YouToOpenTheModule', [view.$t('route.airExportBooking')]))
          return
        }
        location = { name: 'AeBooking', query: {}, params: { jobUuid, branchId, activeTabName }}
        break
      case 'AI':
        if (!view.$checkPermission(['module_AIBooking'])) {
          view.$message.error(view.$t('Message.YouToOpenTheModule', [view.$t('SeaExport.AirOperation')]))
          return
        }
        location = { name: 'AiBooking', query: {}, params: { jobNo, branchId, activeTabName }}
        break
      case 'RE':
      case 'RI':
        if (!view.$checkPermission(['module_RailwayExport', 'module_RailwayOperations'])) {
          view.$message.error(view.$t('Message.YouToOpenTheModule', [view.$t('CargoMsg.Cargo_RailwayOperate')]))
          return
        }
        location = { name: 'ReBooking', query: {}, params: { jobNo, branchId, activeTabName }}
        break
        // case 'IE':
        //   if (!view.$checkPermission(['module_IEBooking'])) {
        //     view.$message.error(view.$t('Message.YouToOpenTheModule', [view.$t('CargoMsg.Cargo_IntegratedOperate')]))
        //     return
        //   }
        //   location = { name: 'IEBooking', query: { jobNo }, params: { branchId }}
        //   break
      default:
        return
    }
  }
  const oldRoute = view.$route
  view.$router.push(lodash.cloneDeep(location))
  setTimeout(() => {
    // 路由无变化，手动刷新
    if (view.$route === oldRoute) {
      const view = view.$store.state.tagsView.visitedViews.find(v => matchView(v, view.$route))
      Object.assign(view.params, location.params)
      refreshView(view)
    }
  }, 100)
}
